import { TableHead as MuiTableHead, TableHeadProps } from '@mui/material';

const TableHead = (props: TableHeadProps) => {
  return <MuiTableHead {...props} />;
};

export default TableHead;
